import { render } from "./FormCreateOrUpdate.vue?vue&type=template&id=555672ac&scoped=true"
import script from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"

import "./FormCreateOrUpdate.vue?vue&type=style&index=0&id=555672ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-555672ac"

export default script